import { PulseWeightTypeDto } from '../api/dto/wallbox.dto'
import { MidMeterType } from '../models/wallbox-model'

/**
 * Function for mapping MID meter status.
 * @param useMidMeter - as boolean
 * @param pulseWeight - as PulseWightTypeDto
 * @returns one of MidMeterType
 */
export const getMidMeterStatus = (useMidMeter: boolean, pulseWeight: PulseWeightTypeDto): MidMeterType => {
  if (!useMidMeter && pulseWeight === PulseWeightTypeDto.pulseWeight0) {
    return 'NO_MID_METER_INSTALLED'
  }

  if (useMidMeter && pulseWeight === PulseWeightTypeDto.pulseWeight1) {
    return 'MID_ECP140D'
  }

  if (useMidMeter && pulseWeight === PulseWeightTypeDto.pulseWeight5) {
    return 'MID_ECP380D'
  }

  return undefined
}
